import { apiClient } from './api';
import type { HealthCheck, CurrentHealthStatus, HealthCheckHistoryResult } from '../types/healthCheck';
import { HealthStatus } from '../types/healthCheck';

// Backend'den gelen string HealthStatus'ü frontend enum'ına çevir
const mapHealthStatus = (status: string | number | HealthStatus): HealthStatus => {
  if (typeof status === 'number') {
    return status as HealthStatus;
  }
  if (typeof status === 'string') {
    switch (status.toUpperCase()) {
      case 'HEALTHY':
        return HealthStatus.Healthy;
      case 'UNHEALTHY':
        return HealthStatus.Unhealthy;
      case 'UNKNOWN':
        return HealthStatus.Unknown;
      default:
        return HealthStatus.Unknown;
    }
  }
  return status as HealthStatus;
};

export const healthCheckService = {
  getHistory: async (
    applicationDefinitionId: string,
    page: number = 1,
    pageSize: number = 20,
    startDate?: Date,
    endDate?: Date
  ): Promise<HealthCheckHistoryResult> => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());

    const response = await apiClient.get<any>(
      `/HealthChecks/history/${applicationDefinitionId}?${params.toString()}`
    );
    
    // HealthStatus string'lerini enum'a çevir
    const mappedItems: HealthCheck[] = (response.data.items || []).map((item: any) => ({
      ...item,
      healthStatus: mapHealthStatus(item.healthStatus),
    }));
    
    const result: HealthCheckHistoryResult = {
      items: mappedItems,
      totalCount: response.data.totalCount || 0,
      page: response.data.page || page,
      pageSize: response.data.pageSize || pageSize,
      totalPages: response.data.totalPages || 0,
    };
    
    console.log('[HealthCheckService] getHistory response:', {
      applicationDefinitionId,
      result,
      firstItem: mappedItems?.[0],
    });
    return result;
  },

  getCurrentStatus: async (applicationDefinitionId: string): Promise<CurrentHealthStatus | null> => {
    try {
      const response = await apiClient.get<any>(
        `/HealthChecks/current/${applicationDefinitionId}`
      );
      
      // HealthStatus string'ini enum'a çevir
      const mappedData: CurrentHealthStatus = {
        ...response.data,
        latestHealthStatus: mapHealthStatus(response.data.latestHealthStatus),
      };
      
      console.log('[HealthCheckService] getCurrentStatus response:', {
        applicationDefinitionId,
        data: mappedData,
        latestHealthStatus: mappedData?.latestHealthStatus,
        latestHealthStatusName: mappedData?.latestHealthStatusName,
        latestDetails: mappedData?.latestDetails,
      });
      return mappedData;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
};











